import { Flex, Table } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getServiceProviderSubscriptionPlanHistoryAction } from "../../../../../../redux/services/service-provider-subscriptions/serviceProviderSubscriptionsServices";
import Spinner from "../../../../../common/spinner/Spinner";
import { dateObjToDispViewDate,timeObjToDispViewTimeWithSuffix } from "../../../../../../utils/utils";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import useDebounce from "../../../../../../hooks/useDebounce";
import { getFineTransactionHistoryAction } from "../../../../../../redux/services/common/commonServices";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const FineTransactionHistory = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { fineTransactionHistory } = useSelector(
    (state) => state.common
  );
  const [searchValue] = useState("");
  const { debouncedValue: debouncedSearchValue } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: fineTransactionHistory?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue
    }
    dispatch(getFineTransactionHistoryAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, debouncedSearchValue]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Configuration.serviceProvider"),
        dataIndex: "duration",
        render: (_, record) => (
          <>{`${record?.organization?.name}`}</>
        ),
      },
      {
        title: t("servicesList.fine"),
        dataIndex: "total_amount",
        key: "total_amount",
        render: (_, record) => <>{`${record?.price?.toFixed(2)} ${record?.currency}`}</>,
      },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{`${dateObjToDispViewDate(record?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
        ),
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    <div className="servicesListContainer">
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Title level={2}>{t("Modules.chatConversation.fineTransactionHistory")}</Title>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={fineTransactionHistory?.data}
            columns={columns}
            pagination = {paginationObj}
          />
        )}
      </Flex>
    </div>
  );
};

export default FineTransactionHistory;
